<script setup lang="ts">
import { ref } from "vue";
import RadioGroup from "@/components/general/RadioGroup/RadioGroup.vue";
import type { RadioOption } from "@/models";
import { useDataLayerStore } from "@/stores/dataLayer.store";
import { AdobeEventTypeEnum } from "@/models";

interface Props {
    options: RadioOption[];
}
const props = defineProps<Props>();

const emit = defineEmits<{
    (e: "update:selectedOption", value: string): void;
}>();

const selectedOption = ref<string>(props.options[0].value as string);

const onSelect = (value: string | number | boolean): void => {
    selectedOption.value = value as string;
    useDataLayerStore().triggerAdobeEvent(
        AdobeEventTypeEnum.InteractionClick,
        `select|Policy Documentation Option|${value}`
    );
    emit("update:selectedOption", value as string);
};
</script>

<template>
    <h3 class="boc-title">Policy Documentation</h3>
    <div class="policy-docs-box grey-border">
        <p>
            We are committed to the environment and look to reduce impacts
            wherever possible. Your documentation for this purchase will be
            automatically saved to a secure area on ‘My Account’.
        </p>
        <b>
            Most customers choose to access their documents online via My
            Account because:
        </b>
        <br />
        <ul>
            <li>they are saved in a secure area</li>
            <li>can be accessed 24/7</li>
            <li>can be printed at any time</li>
        </ul>
        <RadioGroup
            id="policy-documents"
            v-model="selectedOption"
            input-name="policy-documents"
            :options="props.options"
            @change="onSelect"
        />
    </div>
</template>

<style scoped>
.boc-title {
    color: var(--off-black);
    margin: 0;
}

.grey-border {
    border: 1px solid var(--grey-warm);
}

.radio-group {
    flex-direction: column;
}

.policy-docs-box {
    background: var(--pure-white);
    margin-bottom: 1rem;
    padding: 1rem;
}

.policy-docs-box .radio-btn {
    width: 100%;
    display: flex;
}

.policy-docs-box .radio-btn label {
    width: 100%;
    padding-right: 45px;
}

.radio-btn label:hover .radio-btn input[type="radio"]:focus + label {
    border: 2px solid var(--color-primary-light);
    border-radius: 4px;
}

.error {
    color: var(--error-text);
    font-size: 14px;
    margin-top: 0.5rem;
}
</style>
